import { defineStore } from 'pinia'
import rewardsAPI from '@vue3/api/rewards-api.js'
import { emitEventToVuexStore } from '@vue3/utils/common.js'
import NpsStore from '@vue3/store/nps-store'


const rewardsStore = defineStore('rewardsStore', {
  state: () => ({
    engagementInfo: null,
    isHistoryViewed: true,
    showLoyaltySectionLoader: false,
    pointsHistoryList: [],
    rewardData: null,
    giftList: [],
    redeemedHistoryList: [],
    refreshDashboard: false
  }),
  getters: {
    getRewardData (state) {
      return state.rewardData
    }
  },
  actions: {
    setRefreshDashboard (value) {
      this.refreshDashboard = value
    },
    getEngagementInfo ({ param, success, fail }) {
      this.showLoyaltySectionLoader = true
      rewardsAPI.getEngagementInfo(param).then(
        res => {
          const resBody = res.body
          this.showLoyaltySectionLoader = false
          if (resBody && resBody.success) {
            const responseValue = resBody?.value || null
            this.engagementInfo = responseValue
            this.isHistoryViewed = responseValue?.isHistoryViewed
            emitEventToVuexStore('PINIA_UPDATE_ENGAGEMENT_INFO', this.engagementInfo)
            emitEventToVuexStore('PINIA_UPDATE_HISTORY_VIEWED', this.isHistoryViewed)
            NpsStore().setNpsDetatis(responseValue?.feedbackResponse?.triggerFeedback, responseValue?.feedbackResponse?.feedBackId)
            success && success(responseValue)
          } else {
            fail && fail()
          }
        },
        err => {
          this.showLoyaltySectionLoader = false
          fail && fail(err)
        }
      )
    },
    scannedProductList ({ query, success, fail }) {
      rewardsAPI.scannedProductList(query).then(res => {
        const resBody = res.body
        if (resBody?.success && resBody.errorCode === null) {
          success && success(resBody)
        } else {
          fail && fail(res)
        }
      },
      err => {
        fail && fail(err)
      }
      )
    },
    addScannedProduct ({ data, success, fail }) {
      rewardsAPI.addScannedProduct(data).then(res => {
        const resBody = res.body
        if (resBody?.success && resBody.errorCode === null) {
          this.refreshDashboard = true
          success && success(resBody)
        } else {
          fail && fail(res)
        }
      }).catch(err => {
        fail && fail(err)
      })
    },
    downloadProducts ({ query, success, fail }) {
      rewardsAPI.downloadProducts(query).then(res => {
        const resBody = res.body
        success && success(resBody)
      }, err => {
        fail && fail(err)
      })
    },
    uploadProducts ({ data, success, fail }) {
      rewardsAPI.uploadProducts(data).then(res => {
        const resBody = res.body
        if (resBody?.success && resBody.errorCode === null) {
          success && success(resBody)
        } else {
          fail && fail(resBody)
        }
      }, err => {
        fail && fail(err)
      })
    },
    uploadInvoice ({ data, success, fail }) {
      rewardsAPI.uploadInvoice(data).then(res => {
        const resBody = res.body
        if (resBody?.success && resBody.errorCode === null) {
          success && success(resBody)
        } else {
          fail && fail(res)
        }
      }, err => {
        fail && fail(err)
      })
    },
    getDashboardInfo ({ query, success, fail }) {
      rewardsAPI.getDashboardInfo(query).then(res => {
        const resBody = res.body
        if (resBody?.success && resBody.errorCode === null) {
          success && success(resBody.value)
        } else {
          fail && fail(resBody)
        }
      }).catch(err => {
        fail && fail(err)
      })
    },
    getScannedProductDetail ({ data, success, fail }) {
      rewardsAPI.getScannedProductDetail(data).then(res => {
        const resBody = res.body
        if (resBody?.success && resBody.errorCode === null) {
          this.rewardData = resBody.value
          success && success(resBody)
        } else {
          fail && fail(res)
        }
      }).catch(err => {
        fail && fail(err)
      })
    }
  }
})
export default rewardsStore
